import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type ActiveChatChannel = {
  id: string;
  type: string;
};

type ChatPanelState = {
  caseActiveChannels: Record<string, ActiveChatChannel | null>;
  allChatsActiveChannel: ActiveChatChannel | null;

  saveActiveChannel: (channel: ActiveChatChannel, caseId?: string) => void;
  clearActiveChannel: (caseId?: string) => void;
};

export const useChatPanelStore = create<ChatPanelState>()(
  persist(
    (set) => ({
      caseActiveChannels: {},
      allChatsActiveChannel: null,

      saveActiveChannel: (channel, caseId) =>
        caseId
          ? set((state) => ({ caseActiveChannels: { ...state.caseActiveChannels, [caseId]: channel } }))
          : set({ allChatsActiveChannel: channel }),

      clearActiveChannel: (caseId) =>
        caseId
          ? set((state) => ({ caseActiveChannels: { ...state.caseActiveChannels, [caseId]: null } }))
          : set({ allChatsActiveChannel: null }),
    }),
    {
      name: 'chat-panel',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
